import type { ReactNode } from 'react'
import { cn } from '../utils'

export type StatCardProps = {
  label: string
  value?: string | null
  subValue?: string | null
  loading?: boolean
  progress?: number | null
  showProgress?: boolean
  loadingSlot?: ReactNode
  className?: string
}

export function StatCard({
  label,
  value,
  subValue,
  loading,
  progress,
  showProgress = false,
  loadingSlot,
  className,
}: StatCardProps) {
  return (
    <div
      className={cn(
        'flex-1 rounded-lg border border-border bg-card p-4',
        className
      )}
    >
      <div className="space-y-2">
        <span className="text-xs text-muted-foreground/70">{label}</span>
        {loading ? (
          loadingSlot ?? (
            <div className="space-y-2">
              <div className="h-6 w-24 bg-muted/30 rounded animate-pulse" />
              <div className="h-3 w-32 bg-muted/30 rounded animate-pulse" />
            </div>
          )
        ) : (
          <>
            <p className="text-lg font-normal text-foreground">
              {value ?? '—'}
            </p>
            {subValue && (
              <p className="text-xs text-muted-foreground/70">{subValue}</p>
            )}
          </>
        )}
      </div>
      {showProgress && (
        <div className="mt-3 pt-3 border-t border-border/10">
          {loading ? (
            <div className="space-y-2">
              <div className="h-1 w-full bg-muted/30 rounded animate-pulse" />
              <div className="h-3 w-16 bg-muted/30 rounded animate-pulse" />
            </div>
          ) : (
            <>
              <div className="h-1 bg-muted rounded-full overflow-hidden">
                <div
                  className="h-full bg-primary/60 rounded-full transition-all duration-500"
                  style={{ width: `${Math.min(progress ?? 0, 100)}%` }}
                />
              </div>
              <p className="text-xs text-muted-foreground/70 mt-1.5">
                {(progress ?? 0).toFixed(0)}% used
              </p>
            </>
          )}
        </div>
      )}
    </div>
  )
}
